import { UI } from "@/constants";
import { SearchParams } from "@/types";

type ServerFetchProps = {
  path: string;
  params?: SearchParams;
};

export const serverFetchText = async ({ path, params }: ServerFetchProps) => {
  const baseUrl = process.env.API_BASE_URL;
  const token = process.env.API_TOKEN;
  if (!baseUrl || !token) throw new Error(UI.errors.missingEnvironments);

  const url = new URL(path, baseUrl);

  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      if (v === undefined) return;

      if (Array.isArray(v)) {
        v.forEach((val) => url.searchParams.append(k, String(val)));
      } else {
        url.searchParams.set(k, String(v));
      }
    });
  }

  const response = await fetch(url, {
    method: "GET",
    headers: { Authorization: `Bearer ${token}` },
    cache: "no-store",
  });

  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(`API ${response.status}: ${text || response.statusText}`);
  }

  return await response.text();
};